import { render, staticRenderFns } from "./sh_ForceLogout.vue?vue&type=template&id=2b7e7af6&scoped=true&"
import script from "./sh_ForceLogout.vue?vue&type=script&lang=js&"
export * from "./sh_ForceLogout.vue?vue&type=script&lang=js&"
import style0 from "./sh_ForceLogout.vue?vue&type=style&index=0&id=2b7e7af6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e7af6",
  null
  
)

export default component.exports